export default {
  REGISTRATION_VALIDATE_EMAIL_REQUEST: "REGISTRATION_VALIDATE_EMAIL_REQUEST",
  REGISTRATION_VALIDATE_EMAIL_RECEIVE: "REGISTRATION_VALIDATE_EMAIL_RECEIVE",
  REGISTRATION_VALIDATE_EMAIL_ERROR: "REGISTRATION_VALIDATE_EMAIL_ERROR",
  REGISTRATION_VALIDATE_EMAIL_CLEAR_ERROR:
    "REGISTRATION_VALIDATE_EMAIL_CLEAR_ERROR",
  REGISTRATION_VALIDATE_EMAIL_CLEAR: "REGISTRATION_VALIDATE_EMAIL_CLEAR",

  REGISTRATION_VALIDATE_TOKEN_REQUEST: "REGISTRATION_VALIDATE_TOKEN_REQUEST",
  REGISTRATION_VALIDATE_TOKEN_RECEIVE: "REGISTRATION_VALIDATE_TOKEN_RECEIVE",
  REGISTRATION_VALIDATE_TOKEN_ERROR: "REGISTRATION_VALIDATE_TOKEN_ERROR",

  REGISTRATION_VALIDATE_CMF_REQUEST: "REGISTRATION_VALIDATE_CMF_REQUEST",
  REGISTRATION_VALIDATE_CMF_RECEIVE: "REGISTRATION_VALIDATE_CMF_RECEIVE",
  REGISTRATION_VALIDATE_CMF_ERROR: "REGISTRATION_VALIDATE_CMF_ERROR",

  REGISTRATION_REGISTERUSER_REQUEST: "REGISTRATION_REGISTERUSER_REQUEST",
  REGISTRATION_REGISTERUSER_RECEIVE: "REGISTRATION_REGISTERUSER_RECEIVE",
  REGISTRATION_REGISTERUSER_ERROR: "REGISTRATION_REGISTERUSER_ERROR"
};
